// tslint:disable
export var Extauth2ValidationType;
(function (Extauth2ValidationType) {
    // UserName only
    Extauth2ValidationType[Extauth2ValidationType["UserName"] = 0] = "UserName";
    // UserName and Password combo
    Extauth2ValidationType[Extauth2ValidationType["Password"] = 1] = "Password";
})(Extauth2ValidationType || (Extauth2ValidationType = {}));
Extauth2ValidationType['USERNAME'] = 0;
Extauth2ValidationType['PASSWORD'] = 1;
//# sourceMappingURL=Extauth2ValidationType.js.map